import { Injectable } from '@angular/core';
import { DeviceInfo, getDeviceInfo } from '../shared/device';
import { brandFlavor } from 'src/app/brand/brand-context';

@Injectable({
  providedIn: 'root',
})
export class GetterService {
  brand_Name: string = null;

  get(key) {
    if (this.brand_Name == null) {
      this.getID();
      return localStorage.getItem(this.brand_Name + ' ' + key);
    } else {
      return localStorage.getItem(this.brand_Name + ' ' + key);
    }
  }

  set(key, val) {
    if (this.brand_Name == null) {
      this.getID();
      localStorage.setItem(this.brand_Name + ' ' + key, val);
    } else {
      localStorage.setItem(this.brand_Name + ' ' + key, val);
    }
  }

  remove(key) {
    if (this.brand_Name == null) {
      this.getID();
      localStorage.removeItem(this.brand_Name + ' ' + key);
    } else {
      localStorage.removeItem(this.brand_Name + ' ' + key);
    }
  }

  setSessionItem(key: string, value) {
    if (this.brand_Name == null) {
      this.getID();
      sessionStorage.setItem(this.brand_Name + ' ' + key, value);
    } else {
      sessionStorage.setItem(this.brand_Name + ' ' + key, value);
    }
  }
  getSessionItem(key: string) {
    if (this.brand_Name == null) {
      this.getID();
      return sessionStorage.getItem(this.brand_Name + ' ' + key);
    } else {
      return sessionStorage.getItem(this.brand_Name + ' ' + key);
    }
  }
  removeSessionItem(key) {
    if (this.brand_Name == null) {
      this.getID();
      sessionStorage.removeItem(this.brand_Name + ' ' + key);
    } else {
      sessionStorage.removeItem(this.brand_Name + ' ' + key);
    }
  }
  clear() {
  }

  /**
   * Storage keys are namespaced "<brandFlavor> <key>" so brands can share a
   * browser. The flavour comes from brand-context (path or host); it is
   * resolved before the app starts, so a null here means an unknown brand.
   */
  getID() {
    this.brand_Name = brandFlavor();
  }
  
  /** OS / user agent for the checkout WebSource (see shared/device.ts) */
  getDeviceInfo(): DeviceInfo {
    return getDeviceInfo();
  }

  /** True when the portal runs inside the native app webview (`app` session flag, set by AppComponent). */
  isApp(): boolean {
    try {
      return JSON.parse(this.getSessionItem('app')) === true;
    } catch {
      return false;
    }
  }

  /**
   * `Source` for the discount / promo calls (getCheckoutDiscountAmount, ApplyPromoCode,
   * GetDiscountedItemsList, getActiveDiscounts): "App" selects the customer-app channel
   * (DEALS.IsAppDeal) on the API; undefined (website) leaves it on IsOnlineDeal.
   * Order placement is not affected — it carries the channel in WebSource.
   */
  discountSource(): 'App' | undefined {
    return this.isApp() ? 'App' : undefined;
  }

  /** Query string for `getActiveDiscounts` (a GET): `?source=App` inside the app, empty on the website. */
  discountSourceQuery(): string {
    return this.isApp() ? '?source=App' : '';
  }
}
